export default __webpack_public_path__ + "static/media/sf3.29fb5114.svg";